function getVersions() {
  return {
    uk: { code: "uk", currency: "£GBP", name: "United Kingdom", hostname: "kimai.com", pathname: "uk" },
    us: { code: "us", currency: "$USD", name: "International", hostname: "kimai.com", pathname: "us" },
    eu: { code: "eu", currency: "€EUR", name: "Europe", hostname: "kimai.com", pathname: "eu" },
    fr: { code: "fr", currency: "€EUR", name: "France", hostname: "kimai.com", pathname: "fr" },
  }
}

function redirectToLocation(countryCode, forceRedirect = false, alternatePath = false, hasDifferentPathPerLocale) {
  const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us";
  const currentUrl = window.location.href
  const redirectUrl = new URL(currentUrl)
  const hostname = redirectUrl.hostname
  let pathname = redirectUrl.pathname

  pathname = pathname.replace(`/${activeEnv}/`, "")

  const devUrls = [
    "localhost",
    "stg.kimai.com",
  ]

  if (forceRedirect === false
    && devUrls.includes(hostname)) {
    return
  }

  const versions = getVersions()

  redirectUrl.hostname = versions[countryCode].hostname
    
  if (activeEnv === "fr") {
    if (countryCode !== "fr") {
      if (alternatePath) {
        let pureAlternatePath = alternatePath.replace(`/${activeEnv}/`, "")
        let fixedPathname = pathname.replace(pathname, pureAlternatePath)
        pathname = fixedPathname
      }
    }
  } else {
    if (countryCode === "fr" || hasDifferentPathPerLocale) {
      if (alternatePath) {
        let pureAlternatePath = alternatePath.replace(`/${activeEnv}/`, "")
        let fixedPathname = pathname.replace(pathname, pureAlternatePath)
        pathname = fixedPathname
      }
    }
  }

  if (countryCode !== "us") {
    if (!pathname.includes("/learn/")) {
      redirectUrl.pathname = versions[countryCode].pathname + "/" + pathname
    } else {
      if (countryCode === "fr") {
        redirectUrl.pathname = versions[countryCode].pathname + "/" + pathname
      } else {
        redirectUrl.pathname = pathname
      }
    }
  } else {
    redirectUrl.pathname = pathname
  }
  
  let searchParams = redirectUrl.searchParams
  
  searchParams.set("country", countryCode)
  
  redirectUrl.search = searchParams.toString()

  window.location.href = redirectUrl
}

module.exports = {
  redirectToLocation: redirectToLocation,
}
